import {MenuStrategy} from "../MenuStrategy";

export class DispositiviStoricoMenuStrategy extends MenuStrategy {
   constructor() {
    super('Storico', 'Storico', 'app-operations-log');
  }
}
